import { render, staticRenderFns } from "./channel_product.vue?vue&type=template&id=7077f7ca&scoped=true&"
import script from "./channel_product.vue?vue&type=script&lang=js&"
export * from "./channel_product.vue?vue&type=script&lang=js&"
import style0 from "./channel_product.vue?vue&type=style&index=0&id=7077f7ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7077f7ca",
  null
  
)

export default component.exports